<arm-form (submitForm)="submit()" [disableSubmit]="isUnauthorized" class="quota-configuration">
  <arm-form-title>CAC Profiles Configuration</arm-form-title>
  <div class="settings-section">
    <mat-form-field class="warningThreshold">
      <mat-label>Calls Quota Threshold</mat-label>
      <input matInput [(ngModel)]="callsQuotasConfiguration.warningThreshold" type="number" min="1" max="100" name="warningThreshold" required="true">
      <span matSuffix>%</span>
    </mat-form-field>
  </div>
</arm-form>
